<template>
  <div class="text-md">
    <h1 class="h1 text-bold text-uppercase p-b-1 m-0">
      FAQ
    </h1>

    <!--TODO: replace these with a v-for if we ever have to update them-->
    <section>
      <AboutSectionHeading>
        1. How do I find a pro for my home project?
      </AboutSectionHeading>
      <p>
        You can find a pro by submitting a request
        <a href="/" target="_blank" rel="noopener noreferrer"  class="c-depot">
        here</a>. Just describe the work you need
        completed and provide as much detail as you can about the job. We will match your request
        with qualified pros near you. You can review the profiles of our top recommendations and
        choose up to five pros to connect with about your project.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        2. What types of services can I request through Pro Referral?
      </AboutSectionHeading>
      <p>
        Pro Referral can help connect you with pros in the fields of handiwork, painting,
        electrical, plumbing, carpentry, landscaping, and contracting. If you aren’t sure what type
        of pro you need, submit your request and we’ll point you in the right direction.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        3. Is there a charge to use Pro Referral?
      </AboutSectionHeading>
      <p>
        Pro Referral is a free service powered by The Home Depot. There is no charge to request or
        receive referrals.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        4. How does Pro Referral match pros to my request?
      </AboutSectionHeading>
      <p>
        Pro Referral uses a proprietary algorithm to match your request with qualified local pros.
        We’ll recommend the top three pros who meet the criteria of your project, so you can be
        sure you’re connecting with experts in your area.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        5. Does Pro Referral guarantee my pro’s workmanship?
      </AboutSectionHeading>
      <p>
        Pro Referral cannot guarantee the quality of work or materials, but we do guarantee your
        satisfaction with our referral service. We’re confident in the pros we’ve selected and will
        refund up to $500 per unsatisfactory referral.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        6. I’ve submitted a request. What happens next?
      </AboutSectionHeading>
      <p>
        Once you have chosen pros and submitted your request, we’ll send you an email confirmation
        and notify the pros you selected. They will reach out directly to you to discuss the job
        within 24 hours. After connecting with each pro and comparing your options, pricing
        estimates, and other details, you can choose the one who is the best fit for your project
        and budget.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        7. Do you share my personal information with my selected pros?
      </AboutSectionHeading>
      <p>
        Your privacy is of the utmost importance to us, therefore,
        we’ll only share necessary personal information to the pros you matched with so that they
        may contact you regarding your project. This information includes your phone number
        and email address.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        8. I decided on a pro for my project. How do I get the job started?
      </AboutSectionHeading>
      <p>
        When you’ve decided who to hire for the project, contact the pro so you can make
        arrangements together. Pro Referral does not coordinate scheduling, contracts, or payments,
        so be sure to work out all the details with your pro before work begins.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        9. How can I review my pro’s work?
      </AboutSectionHeading>
      <p>
        Only customers who have connected with pros can leave a review. Once your job is complete,
        you can log into your Pro Referral account or use the link sent in an email to provide
        feedback. You can rate your pro on a scale of one to five and provide a written review of
        the work.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        10. Can I review a pro even if I didn’t hire them for a job?
      </AboutSectionHeading>
      <p>
        Absolutely! We want you to share your opinion of any pros you connect with on Pro Referral.
        Your feedback helps other homeowners make informed decisions.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        11. Can pros remove or dispute negative reviews?
      </AboutSectionHeading>
      <p>
        Your neighbors want to know about both good and bad experiences, so we encourage honest
        feedback. As long as reviews are factual and not offensive, we will not remove them from a
        pro’s profile.
      </p>
    </section>

  </div>
</template>

<script>
import AboutSectionHeading from '../../AboutSectionHeading';

export default {
  name: 'frequent-questions',
  metaInfo: {
    title: 'FAQ',
  },
  components: {
    AboutSectionHeading,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  p {
    @include padding-bottom(1);
  }
</style>
